import React from "react";

import Pluralize from "pluralize";

import { Typography, SearchBar } from "clearsense-ui/components";
import Filter from "components/Common/FilterHeader/Filter";
import {
  FILTER_CONDITIONS,
  FILTER_OPERATIONS,
} from "components/DataManagement/constants/stewardFilter";

const ActionHeader = ({
  filterConditions,
  setFilterConditions,
  search,
  setSearch,
  totalCount,
}) => (
  <div className="flex justify-between my-4">
    <div className="flex items-center w-2/6 space-x-4">
      <Typography style="large" type="bold">
        {Pluralize("Analysis", totalCount ?? 0, true)}
      </Typography>
      <Filter
        title="Analyses"
        filterConditions={filterConditions}
        setFilterConditions={setFilterConditions}
        conditionOptions={FILTER_CONDITIONS}
        filterOperations={FILTER_OPERATIONS}
      />
    </div>

    <div
      className="flex items-center w-2/6 space-x-4"
      data-cy="analysis-subheader-right-action-block-div"
    >
      <SearchBar
        placeholder="Search Analyses"
        className="w-40"
        value={search}
        onChange={e => setSearch(e.target.value.trim())}
      />
    </div>
  </div>
);

export default ActionHeader;
